import { wagmiConfig } from "@wagmiconfig";
import { isAddress } from "viem";
import { getAccount } from "wagmi/actions";

export const LOAD_MESSAGES = () => `
{
  notifications {
    id
    created
		status
    recipient
    vault_address
    title 
    body
    icon
    action_url
    action_label
  }
}
`;

export const MARK_READ = () => `
`
